export default __webpack_public_path__ + "static/media/solarPlusApp.e82a2d5a.png";